import React from 'react';

type PaperSectionProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'heavy' | 'very-heavy' | 'super-heavy' | 'card' | 'modal';
  style?: React.CSSProperties;
  texturedEdge?: boolean;
  deckledEdge?: boolean;
  onClick?: () => void;
};

export function PaperSection({ 
  children, 
  className = '', 
  variant = 'default',
  style,
  texturedEdge = false,
  deckledEdge = false,
  onClick
}: PaperSectionProps) {
  let variantClass = '';
  
  switch (variant) {
    case 'super-heavy':
      variantClass = 'paper-texture-super-heavy shadow-sm';
      break;
    case 'very-heavy':
      variantClass = 'paper-texture-very-heavy shadow-sm';
      break;
    case 'heavy':
      variantClass = 'paper-texture-heavy shadow-sm';
      break;
    case 'card':
      variantClass = 'paper-texture shadow-md';
      break;
    case 'modal':
      variantClass = 'modal-paper-texture shadow-lg';
      break;
    default:
      variantClass = 'paper-texture';
  }
  
  // Add textured edge and deckled edge classes if requested
  const edgeClasses = [
    texturedEdge ? 'textured-edge' : '',
    deckledEdge ? 'deckled-edge' : ''
  ].filter(Boolean).join(' ');
  
  return (
    <div 
      className={`${variantClass} ${edgeClasses} ${className} p-4 rounded-sm`} 
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
} 